
import { ElTable } from 'element-plus'
import { defineComponent, ref } from 'vue'
import { useI18n } from 'vue-i18n'
export default defineComponent({
  props: {
    tableData: {
      type: Array,
      required: true
    },
    columnStruct: {
      type: Array,
      required: true
    },
    listLoading: {
      type: Boolean,
      required: false,
      default: false
    },
    hadOperate: {
      type: Boolean,
      required: false,
      default: true
    },
    operateColumnWidth: {
      type: Number,
      required: false,
      default: 180
    },
    sort: {
      type: String,
      required: false,
      default: 'createTime'
    },
    order: {
      type: String,
      required: false,
      default: 'desc'
    },
    haveSelection: {
      type: Boolean,
      required: false,
      default: true
    }
  },
  emits: ['handleOrder', 'handleSelection'],
  setup(props, context) {
    const { t } = useI18n()
    const tableRef = ref(ElTable)
    const handleSelection = (item: any[]) => {
      context.emit('handleSelection', item.map(i => i.id))
    }
    const handleOrder = (column: any) => {
      context.emit('handleOrder', column)
    }
    return { t, tableRef, handleSelection, handleOrder }
  }
})
